export default __webpack_public_path__ + "static/media/ps_09.68c3dfa2.png";